export const version = '1.236.0'
export const buildTime = 'Wed, 23 Apr 2025 18:10:35 GMT'
